import { z } from 'zod';

export const completeEvaluationSessionParamsSchema = z.object({
  evaluation_session_id: z.uuid(),
});

export const completeEvaluationSessionSchema = z.object({
  answers: z
    .array(
      z.object({
        question_id: z.string().min(1, 'Question ID is required'),
        value: z.number().min(0).max(10, 'Answer value must be between 0 and 10'),
      }),
    )
    .min(1, 'At least one answer is required'),
});

export type CompleteEvaluationSessionParams = z.infer<typeof completeEvaluationSessionParamsSchema>;
export type CompleteEvaluationSessionPayload = z.infer<typeof completeEvaluationSessionSchema>;
